export default __webpack_public_path__ + "static/media/Send_msg_white.3e047996.svg";